import { GridReducer } from '../../../../common/grid/grid.reducer';
import {GridFilterReducer} from '../../../../common/grid/filter/grid-filter.reducer';
import * as GRID from '../../../../common/grid/grid.constants';
import * as FORM from '../../../../common/form/input/input.constants';
import { TYPES } from './adm-accounts-clients-action-type.constants';
import { IDS } from './adm-accounts-clients-action-id.constants';
import get from 'lodash/get';
import set from 'lodash/set';

/**
 * @function admAccountsClientsReducer
 * @param state {object}
 * @param action {object}
 * @returns {object} Redux Store
 * @memberOf Reducers
 */
export function admAccountsClientsReducer(state = undefined, action = undefined) {

    if (typeof state === 'undefined') {
        return {
            [IDS.admAccountsClientsGrid]: GridReducer(),
            [IDS.admAccountsClientDetails]: {
                // outsourced_management_provider: null,
                // site_capabilities: [],
            },
            [IDS.admAccountsClientExternalRolesGrid]: GridReducer(),

            hofRoleOptions: [],
            sloRoleOptions: [],

            selectedNewRoleLevel: null,
            newRoleLevelOptions: [
                // {label: 'Corporate', value: 'cla'},
                {label: 'Head Office', value: 'hof'},
                {label: 'Site Location', value: 'slo'},
            ],
            newExternalJobTitle: null,
            newExternalId: null,
            selectedNewRole: null,
            newRoleOptions: [],
            outsourcedManagementProviderOptions: [],
            siteCapabilitiesOptions: [],
        };
    }

    switch (action.type) {
        case TYPES.FETCH_CLIENT_ACCOUNT_DETAILS:
            if (action.id === IDS.admAccountsClients) {
                return set({...state}, IDS.admAccountsClientDetails, action.data)
            }
        case TYPES.RESET_CLIENT_DETAILS:
            if (action.id === IDS.admAccountsClients) {
                return set({...state}, IDS.admAccountsClientDetails, {})
            }
        case TYPES.RESET_GRID_FILTER:
            if (action.id === IDS.admAccountsClients) {
                return set({...state}, `${IDS.admAccountsClientsGrid}.filter`, GridFilterReducer())
            }
        case TYPES.FETCH_ROLE_OPTIONS:
            if (action.id === IDS.admAccountsClients) {
                state = {...state};
                if (action.path === 'hofRoleOptions') {
                    state.newRoleOptions = action.data;
                }
                return set(state, action.path, action.data)
            }
        case TYPES.FETCH_OUTSOURCED_MANAGEMENT_PROVIDER_OPTIONS:
            if (action.id === IDS.admAccountsClients) {
                return {
                    ...state,
                    outsourcedManagementProviderOptions: action.items.map(item => ({
                        value: item.uuid,
                        label: item.name
                    }))
                }
            }
        case TYPES.FETCH_SITE_CAPABILITIES_OPTIONS:
            if (action.id === IDS.admAccountsClients) {
                return {
                    ...state,
                    siteCapabilitiesOptions: action.items.map(item => ({
                        value: item.code,
                        label: item.name
                    }))
                }
            }
        case GRID.GRID_RESET:
            if (action.id === IDS.admAccountsClients) {
                state = set({...state} ,`${action.path}.filter.keyword`, null);
                // and continue to be handled below in
            }

        case GRID.GRID_INIT:
        case GRID.GRID_FILTER:
        case GRID.GRID_FILTER_TOGGLE:
        case GRID.GRID_RESET_FILTER:
        case GRID.GRID_INIT_FILTER:
        case GRID.GRID_LOADING:
        case GRID.GRID_PAGINATE:
        case GRID.GRID_RELOAD:
        case GRID.GRID_FETCH:
        case GRID.GRID_SELECT:
        case GRID.GRID_SELECT_ALL:
        case GRID.GRID_DESELECT:
        case GRID.GRID_DESELECT_ALL:
            if(action.id === IDS.admAccountsClients) {
                return {...state,
                    [action.path]: GridReducer(get(state, action.path), action)
                };
            }
        case FORM.INPUT_SELECT:
        case FORM.INPUT_TEXT:
        case FORM.INPUT_TEXT_AREA:
        case FORM.INPUT_CHECKBOX:
        case FORM.INPUT_DATE:
        case FORM.INPUT_RADIO:
            if (action.id === IDS.admAccountsClients) {
                if (action.path === 'selectedNewRoleLevel') {
                    return {...state,
                        newRoleOptions: get(state, `${action.input}RoleOptions`)
                    }
                }

                if(action.path && action.path.startsWith(IDS.admAccountsClientsGrid)) {
                    const filter = {
                        [action.path.split('.').pop()]: action.input
                    };
                    action.path = IDS.admAccountsClientsGrid;
                    return set({...state}, action.path,
                        GridReducer(get(state, action.path), { type: GRID.GRID_FILTER, filter })
                    )
                }
                return set({...state}, action.path, action.input)
            }
        // case 'LOCATION_SELECTED': // slo select-cascade.js
            // if (action.id === IDS.accreditationSettingsHeadOffices) {
                // return set({...state}, 'headOffices.selectedHeadOfficeUuid', action.uuid)
            // }
        default:
            return state;
        }
}
